export default __webpack_public_path__ + "static/media/sarita.team.0b6f05ed.png";